import axiosInstance from '@/libs/axios_config.ts'
import { FamilyApplicationEndpoints } from '@/apis/family_application/requests.ts'
import { z } from 'zod'
import { RequestResponse } from '@/common/types_and_interfaces.ts'
import { parseRequestError } from '@/common/utilities.ts'

const IncomeVerificationResponseSchema = z.object({
  message: z.string(),
})

export type IncomeVerificationResponse = z.infer<
  typeof IncomeVerificationResponseSchema
>

export const submitDocument = async (
  payload: FormData
): Promise<RequestResponse<IncomeVerificationResponse>> => {
  try {
    const response = await axiosInstance.post(
      FamilyApplicationEndpoints.post_residency_document,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )

    return {
      data: IncomeVerificationResponseSchema.parse(response.data),
      error: null,
    }
  } catch (error) {
    return { data: null, error: parseRequestError(error) }
  }
}
